import { gql } from "@apollo/client";

export const Dashboards = gql`
query MyQuery($id: String) {
    aatmsv4_crews(where: {crewid: {_eq: $id}}) {
      active
      addresspmt
      addresstemp
      approved
      birthdate
      clienstid
      ecode
      email
      emailpersonal
      joiningdate
      leavingdate
      license
      managersid
      name
      phone1
      phone2
      photo
      ranksid
      airport {
        airport
      }
      fleet {
        aircraft
        clientname
      }
      rank {
        rank
      }
      manager {
        managername
      }
      client {
        crewmessage
      }
    }
  }
  `
export const GetQualificationCert = gql`
query MyQueryQualification(
  $id:String
) {
  aatmsv4_qualifications(where: {subcategory: {_eq: Mandatory}, qualificationrecords: {crewid: {_eq: $id}}}) {
    qualificationrecords {
      crew {
        crewid
      }
      document
      validdate
    }
    banner
    qcode
    qualification
  }
}
  `
export const GroundFormQuery = gql`
query MyQuery(
  $id:String
) {
  aatmsv4_groundforms(where: {active: {_eq: true}, subcategory: {_eq: Mandatory}, fleet: {crews: {crewid: {_eq: $id }}}}) {
    validity
    blankform
    groundformname
  }
}
`
export const aircraftFormQuery = gql`
query MyQuery(
  $id:String
) {
  aatmsv4_airformrecords(where: {active: {_eq: true}, crew: {crewid: {_eq: $id}}, subcategory: {_eq: Mandatory}, published: {_eq: true}}) {
    airformname
    airrecord
    validtill
  }
}

`
export const simformQuery = gql`
  query MyQuery(
    $id:String
  ) {
    aatmsv4_simformrecords(where: {crew: {crewid: {_eq:$id }}, subcategory: {_eq: Mandatory}, active: {_eq: true}, published: {_eq: true}}) {
      simrecord
      validtill
      simformname
      resulttext
      date
    }
  }
  `
export const expire_doc = gql`
query c_dash_doc_expired(
  $id: String
  $date: date
) {
  aatmsv4_qualificationrecords(where: {crewid: {_eq: $id}, active: {_eq: true}, validdate: {_lt: $date}}) {
    qcode
    document
    qualification
  }
}
`
export const Qualificationwarning = gql`
query qualicheck1(
  $clientsid: uuid
  $date:date  
  $id:String
) {
  aatmsv4_qualifications(order_by: {qcode: asc}, where: {clientsid: {_eq: $clientsid}, active: {_eq: true}, subcategory: {_eq: Mandatory}}) {
    clientsid
    qid
    qcode
    qualification
    qualificationrecords(where: {validdate: {_gte: $date}, crewid: {_eq: $id}}) {
      qrid
      qualification
    }
  }
}
`
export const DeleteMissingQ = gql`
mutation muDeleteMissingQ (
  $id:String
) {
  delete_aatmsv4_missingq(where: {crewid: {_eq: $id}}) {
    returning {
      clientsid
    }
  }
}
`
export const InsertMissingQ = gql`
mutation InsMyMutation(
  $clientsid:uuid
  $id:String
  $qcode:String
  $qid:uuid
  $qname:String
  $qrid:uuid
) {
  insert_aatmsv4_missingq(objects: {clientsid: $clientsid, crewid: $id,qcode: $qcode, qid: $qid, qname: $qname, qrid: $qrid}) {
    returning {
      clientsid
    }
  }
}
`
export const MissingQ = gql`
query qualicheck2(
  $id:String
) {
  aatmsv4_missingq(where: {crewid: {_eq: $id }, qrid: {_is_null: false}}) {
  qcode
  qname 
  }
 }
 `
